module.exports = __webpack_public_path__ + "static/media/no_avatar_hover.0b74bd6d.jpg";